import { Button } from "PFComponents/button";
import React, { SyntheticEvent } from "react";

import defaultTheme from "./marketplace_button.module.scss";
import successTheme from "./marketplace_success_button.scss";
import tertiaryTheme from "./marketplace_tertiary_button.module.scss";
import navigationalTheme from "./navigation_button.module.scss";

const THEMES_TABLE = {
  default: defaultTheme,
  navigation: navigationalTheme,
  tertiary: tertiaryTheme,
  success: successTheme
} as const;

export type MarketplaceButtonProps = {
  onClick: () => void;
  theme?: keyof typeof THEMES_TABLE;
  disabled?: boolean;
  className?: string;
  kind?: "primary" | "tertiary" | "danger";
  onMouseEnter?: (event: SyntheticEvent) => void;
  onMouseLeave?: (event: SyntheticEvent) => void;
  displayHover?: boolean;
};

export const MarketplaceButton = ({
  onClick,
  theme = "default",
  disabled,
  kind,
  className,
  children,
  onMouseEnter,
  onMouseLeave,
  displayHover = true
}: React.PropsWithChildren<MarketplaceButtonProps>) => (
  <Button
    onClick={onClick}
    theme={THEMES_TABLE[theme]}
    kind={kind}
    disabled={disabled}
    className={className}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    displayHover={displayHover}
  >
    {children!}
  </Button>
);
